/* eslint-disable no-restricted-imports */
import { Between } from './validate/between';
import { BetweenEqual } from './validate/betweenEqual';
import { Equal } from './validate/equal';
import { EqualAddress } from './validate/equalAddress';
import { EqualBytes32 } from './validate/equalBytes32';
import { GreaterEqual } from './validate/greaterEqual';
import { GreaterThan } from './validate/greaterThan';
import { LessEqual } from './validate/lessEqual';
import { LessThan } from './validate/lessThan';
var getters = {
    Between: Between,
    BetweenEqual: BetweenEqual,
    Equal: Equal,
    EqualAddress: EqualAddress,
    EqualBytes32: EqualBytes32,
    GreaterEqual: GreaterEqual,
    GreaterThan: GreaterThan,
    LessEqual: LessEqual,
    LessThan: LessThan,
};
export var TokenValidator = {
    getters: getters,
};
